export default __webpack_public_path__ + "static/media/select_game.418237e7.png";